import type { ThemeMode } from '@/hooks/useLightMode'

import { tokenPrefix } from '@hivewatch/dark'

/**
 * Shared dark-rebrand surface tokens for the incident-notification surfaces —
 * the notifications tab / drawers (`getNotificationsTabTokens`) and the
 * incoming-alert toasts (`getNotificationToastTokens`). Each feature helper
 * spreads this base and adds its own surface-specific accents, so the shared
 * choices (and the surface light/dark asymmetry) live in one place.
 *
 * Note the surface token is not a straight prefix swap: dark uses
 * `bg.card-elevated` while the light palette only exposes `bg.card`.
 */
export const getIncidentSurfaceTokens = (mode: ThemeMode) => {
  const p = tokenPrefix(mode) // '' | 'light.'
  return {
    surface: mode === 'light' ? 'light.bg.card' : 'bg.card-elevated',
    border: `${p}border.subtle`,
    textPrimary: `${p}text.primary`,
    textSecondary: `${p}text.secondary`,
    // Legacy brand blue for incident-reference links.
    incidentLink: `${p}text.incident-link`,
  }
}
